import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// Here will be all imports with extension methods that will be shared globally across the app.
import 'app/core/extensions/array';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
